import { render } from "./AdditionalCertificate.vue?vue&type=template&id=f444c76e"
import script from "./AdditionalCertificate.vue?vue&type=script&lang=js"
export * from "./AdditionalCertificate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\oaromasodun\\Desktop\\MarinePortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__